/**
 * Available cell events.
 */
export enum CellEvent {
    VALUE_CHANGED       = 'value.changed',
    FORMULA_CHANGED     = 'fomula.changed',
    FORMULA_CALCULATED  = 'formula.calculated',
    CALCULATED          = 'calculated',

    ELEMENT_MOUNTED     = 'element.mounted',
}
